// removed by extract-text-webpack-plugin
module.exports = {"radio-group-container":"ToggleButton__radio-group-container","radioGroupContainer":"ToggleButton__radio-group-container","black-background":"ToggleButton__black-background","blackBackground":"ToggleButton__black-background","white-background":"ToggleButton__white-background","whiteBackground":"ToggleButton__white-background","container-row":"ToggleButton__container-row","containerRow":"ToggleButton__container-row","container-column":"ToggleButton__container-column","containerColumn":"ToggleButton__container-column"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/ToggleButton/ToggleButton.css
// module id = 554
// module chunks = 8